import { Collection } from "@/components/cart/types";
import { ValidTextResponse } from "@/types/actions";
import { validateText } from "@/utils/utils";

export const validateCollectionName = (
  name: string,
  collections: Collection[]
): ValidTextResponse => {
  const validation = validateText(name);

  let isValid: boolean = validation.isValid;
  let message: string | undefined = validation.message;

  // Additional check for duplicate names
  if (collections.find(({ title }) => title === name)) {
    message = "A collection with that name already exists.";
  }

  return { isValid: isValid && message === undefined, message };
};
